module.exports = {
  billing_reconciliation: 'Đối chiếu',
  billing_bill: 'Hóa đơn',
  billing_accountStatement: 'Bảng đối chiếu',
  billing_cancel: 'Hủy',
  billing_return: 'Quay lại',
  billing_save: 'Lưu',
  billing_edit: 'Chỉnh sửa',
  billing_collectInvoice: 'Nhận hóa đơn',
  billing_drawInvoice: 'Xuất hóa đơn',
  billing_writeOff: 'Thanh toán',
  billing_applyForPayment: 'Yêu cầu thanh toán',
  billing_paymentBillState: 'Trạng thái phiếu chi',
  billing_print: 'In',
  billing_adjustBillDate: 'Điều chỉnh ngày hóa đơn',
  billing_addCharges: 'Thêm chi phí',
  billing_deleteCharges: 'Xóa chi phí',
  billing_deleteAll: 'Xóa tất cả',
  billing_viewDeleteChargeDetail: 'Xem/Xóa chi tiết',
  billing_newAdjustment: 'Thêm điều chỉnh',
  billing_editAdjustment: 'Sửa điều chỉnh',
  billing_deleteAdjustment: 'Xóa điều chỉnh',
  billing_diffCharge: 'Xử lý chênh lệch',
  billing_cancelConfirm: 'Hủy xác nhận',
  billing_batchConfirm: 'Xác nhận hàng loạt',
  billing_reconciliationAmount: 'Số tiền đối chiếu',
  billing_exchangeRate: 'Tỷ giá',
  billing_charges: 'Chi phí',
  billing_business: 'Nghiệp vụ',
  billing_recheck: 'Kiểm tra',
  billing_cancelRecheck: 'Hủy kiểm tra',
  includeAdjustmentCharge: 'Có bao gồm chi phí điều chỉnh không',
  billing_recheckTip: 'Vui lòng xác nhận hóa đơn trước khi kiểm tra',
  billing_recheckStatus: 'Trạng thái kiểm tra hóa đơn',
  billing_reviewPeople: 'Người kiểm tra hóa đơn',
  billing_reviewDate: 'Thời gian kiểm tra hóa đơn',
  billingView_Determine: 'Xác nhận',
  billingView_Close: 'Đóng',
  chargeList_query: 'Tìm kiếm',
  chargeList_newBill: 'Tạo hóa đơn mới',
  chargeList_startReconciliation: 'Bắt đầu đối chiếu',
  chargeList_drawCollectInvoice: 'Xuất/Nhận hóa đơn',
  chargeList_writeOff: 'Thanh toán',
  chargeList_applyForPayment: 'Yêu cầu thanh toán',
  chargeList_submission: 'Gửi',
  chargeList_cancelSubmit: 'Hủy gửi',
  chargeList_revenueAndExpenditureMethod: 'Phương thức thu chi',
  chargeList_invoiceRevenueAndExpenditureMethod: 'Loại thu chi hóa đơn',
  chargeList_receivables: 'Phải thu',
  chargeList_payables: 'Phải trả',
  chargeList_all: 'Tất cả',
  chargeList_feeType: 'Loại chi phí',
  chargeList_domestic: 'Nội địa',
  chargeList_international: 'Nước ngoài',
  chargeList_reconciliationType: 'Loại đối chiếu',
  chargeList_accordingToCharges: 'Theo chi phí',
  chargeList_accordingToBusiness: 'Theo nghiệp vụ',
  chargeList_cancelReconciliation: 'Hủy đối chiếu',
  chargeList_saveReconciliation: 'Lưu đối chiếu',
  chargeList_newAdjustment: 'Thêm điều chỉnh',
  chargeList_editAdjustment: 'Sửa điều chỉnh',
  chargeList_deleteAdjustment: 'Xóa điều chỉnh',
  chargeList_diffCharge: 'Xử lý chênh lệch',
  chargeList_cancelConfirm: 'Hủy xác nhận',
  chargeList_batchConfirm: 'Xác nhận hàng loạt',
  billingCharge_businessNumber: 'Mã nghiệp vụ',
  billingCharge_consignationCompany: 'Đơn vị ủy thác',
  billingCharge_settlementCompany: 'Đơn vị thanh toán',
  billingCharge_mblNo: 'Số vận đơn chính',
  billingCharge_vessel: 'Tên tàu',
  billingCharge_voyage: 'Chuyến bay/Chuyến tàu',
  billingCharge_carrier: 'Người vận chuyển',
  billingCharge_billNo: 'Số hóa đơn',
  billingCharge_invoiceNo: 'Số hóa đơn',
  billingCharge_itemNo: 'Mã dự án',
  billingCharge_businessType: 'Loại nghiệp vụ',
  billingCharge_businessStatus: 'Trạng thái nghiệp vụ',
  billingCharge_solicitationType: 'Loại nhận hàng',
  billingCharge_chargeItem: 'Tên chi phí',
  billingCharge_feeStatus: 'Trạng thái chi phí',
  billingCharge_confirmStatus: 'Trạng thái xác nhận',
  billingCharge_businessDate: 'Ngày nghiệp vụ',
  billingCharge_amountRange: 'Khoảng tiền',
  billingCharge_receivablesInvoicingDate: 'Ngày lập hóa đơn phải thu',
  billingCharge_currency: 'Loại tiền',
  billingCharge_operation: 'Thao tác',
  billingCharge_sales: 'Bán hàng',
  billingCharge_advanceMoneyForAnotherOrNot: 'Có ứng trước không',
  billingCharge_adjustedOrNot: 'Có điều chỉnh không',
  billingCharge_wroteOffOrNot: 'Đã thanh toán chưa',
  billingCharge_generatedBillsOrNot: 'Đã lập hóa đơn chưa',
  billingCharge_invoicedOrNot: 'Đã xuất hóa đơn chưa',
  billingCharge_appliedForPaymentOrNot: 'Đã yêu cầu thanh toán chưa',
  billingCharge_drawABbillOrNot: 'Cần xuất hóa đơn không',
  billingCharge_department: 'Phòng ban',
  billingCharge_contactPerson: 'Người liên hệ',
  billingCharge_settlementType: 'Loại thanh toán',
  billingCharge_invoicingMethod: 'Phương thức xuất hóa đơn',
  billingCharge_accrued: 'Đã trích lập',
  billingCharge_receivablesInvoicingStatus: 'Trạng thái hóa đơn phải thu',
  billingCharge_bookingNo: 'Mã đặt chỗ',
  billingCharge_unitPrice: 'Đơn giá',
  billingCharge_invoiceHeader: 'Tên trên hóa đơn',
  billingCharge_businessReferenceNumber: 'Số tham chiếu nghiệp vụ',
  billingCharge_warehouseNo: 'Số nhập kho',
  billingCharge_vesselAndVoyage: 'Tên tàu/chuyến',
  billingCharge_portOfLoading: 'Cảng đi',
  billingCharge_portOfTransfer: 'Cảng trung chuyển',
  billingCharge_portOfDestination: 'Cảng đích',
  billingCharge_portOfLoadingSeaport: 'Cảng đi (cảng biển)',
  billingCharge_portOfLoadingAirport: 'Cảng đi (cảng hàng không)',
  billingCharge_portOfDestinationSeaport: 'Cảng đích (cảng biển)',
  billingCharge_portOfDestinationAirport: 'Cảng đích (cảng hàng không)',
  billingCharge_portOfDischargeSeaport: 'Cảng dỡ hàng (cảng biển)',
  billingCharge_portOfDischargeAirport: 'Cảng dỡ hàng (cảng hàng không)',
  billingCharge_financialDate: 'Ngày tài chính',
  billingCharge_domesticOrInternational: 'Nội địa/Quốc tế',
  billingCharge_paymentType: 'Loại thanh toán',
  billingCharge_amount: 'Số lượng',
  billingCharge_taxIncludedPrice: 'Giá bao gồm thuế',
  billingCharge_taxExcludedPrice: 'Giá chưa bao gồm thuế',
  billingCharge_taxAmount: 'Số tiền thuế',
  billingCharge_theAmountOfWriteOffs: 'Số tiền đã thanh toán',
  billingCharge_amountNotWrittenOff: 'Số tiền chưa thanh toán',
  billingCharge_reconciliationAmount: 'Số tiền đối chiếu',
  billingCharge_difference: 'Chênh lệch',
  billingCharge_confirmationRemarks: 'Ghi chú xác nhận',
  billingCharge_confirmState: 'Đã xác nhận hay chưa',
  billingCharge_creator: 'Người tạo',
  billingCharge_dateCreated: 'Ngày tạo',
  billingCharge_remarks: 'Ghi chú',
  billingJob_businessNumber: 'Số nghiệp vụ',
  billingJob_consignationCompany: 'Đơn vị ủy thác',
  billingJob_settlementCompany: 'Đơn vị thanh toán',
  billingJob_mblNo: 'Số vận đơn chính',
  billingJob_vessel: 'Tên tàu',
  billingJob_voyage: 'Chuyến',
  billingJob_carrier: 'Người vận chuyển',
  billingJob_billNo: 'Số hóa đơn',
  billingJob_invoiceNo: 'Số hóa đơn',
  billingJob_itemNo: 'Số dự án',
  billingJob_businessType: 'Loại nghiệp vụ',
  billingJob_soNo: 'Số đơn hàng',
  billingJob_businessStatus: 'Trạng thái nghiệp vụ',
  billingJob_solicitationType: 'Loại nhận hàng',
  billingJob_chargeItem: 'Tên chi phí',
  billingJob_feeStatus: 'Trạng thái chi phí',
  billingJob_confirmStatus: 'Trạng thái xác nhận',
  billingJob_businessDate: 'Ngày nghiệp vụ',
  billingJob_amountRange: 'Khoảng tiền',
  billingJob_receivablesInvoicingDate: 'Ngày phải thu hóa đơn',
  billingJob_currency: 'Loại tiền tệ',
  billingJob_operation: 'Thao tác',
  billingJob_sales: 'Bán hàng',
  billingJob_advanceMoneyForAnotherOrNot: 'Có ứng trước không',
  billingJob_adjustedOrNot: 'Có điều chỉnh không',
  billingJob_wroteOffOrNot: 'Đã thanh toán chưa',
  billingJob_generatedBillsOrNot: 'Đã tạo hóa đơn chưa',
  billingJob_invoicedOrNot: 'Đã xuất hóa đơn chưa',
  billingJob_appliedForPaymentOrNot: 'Đã yêu cầu thanh toán chưa',
  billingJob_drawABbillOrNot: 'Có cần xuất hóa đơn không',
  billingJob_department: 'Phòng ban',
  billingJob_contactPerson: 'Người liên hệ',
  billingJob_settlementType: 'Loại thanh toán',
  billingJob_invoicingMethod: 'Phương thức xuất hóa đơn',
  billingJob_accrued: 'Đã trích lập',
  billingJob_receivablesInvoicingStatus: 'Trạng thái hóa đơn phải thu',
  billingJob_bookingNo: 'Mã đặt chỗ',
  billingJob_unitPrice: 'Đơn giá',
  billingJob_invoiceHeader: 'Tên hóa đơn',
  billingJob_businessReferenceNumber: 'Số tham chiếu nghiệp vụ',
  billingJob_warehouseNo: 'Mã nhập kho',
  billingJob_vesselAndVoyage: 'Tên tàu/chuyến',
  billingJob_portOfLoading: 'Cảng đi',
  billingJob_portOfTransfer: 'Cảng trung chuyển',
  billingJob_portOfDestination: 'Cảng đến',
  billingJob_portOfLoadingSeaport: 'Cảng đi (cảng biển)',
  billingJob_portOfLoadingAirport: 'Cảng đi (cảng hàng không)',
  billingJob_portOfDestinationSeaport: 'Cảng đến (cảng biển)',
  billingJob_portOfDestinationAirport: 'Cảng đến (cảng hàng không)',
  billingJob_portOfDischargeSeaport: 'Cảng dỡ hàng (cảng biển)',
  billingJob_portOfDischargeAirport: 'Cảng dỡ hàng (cảng hàng không)',
  billingJob_financialDate: 'Ngày tài chính',
  billingJob_domesticOrInternational: 'Trong nước/ngoài nước',
  billingJob_paymentType: 'Loại thanh toán',
  billingJob_amount: 'Số lượng',
  billingJob_taxIncludedPrice: 'Giá bao gồm thuế',
  billingJob_taxExcludedPrice: 'Giá chưa bao gồm thuế',
  billingJob_taxAmount: 'Số tiền thuế',
  billingJob_theAmountOfWriteOffs: 'Số tiền thanh toán',
  billingJob_amountNotWrittenOff: 'Số tiền chưa thanh toán',
  billingJob_reconciliationAmount: 'Số tiền đối chiếu',
  billingJob_difference: 'Chênh lệch',
  billingJob_confirmationRemarks: 'Ghi chú xác nhận',
  billingJob_ReviewRemarks: 'Nhận xét kiểm duyệt',
  InquiryLetterRemark: 'Ghi chú thư xác nhận',
  WarmPromptAppend: 'Gợi ý: Ghi chú được điền sẽ được thêm vào sau thông tin ghi chú tài chính ban đầu.',
  WarmPromptOverwrite: 'Gợi ý: Ghi chú được điền sẽ ghi đè lên ghi chú thư xác nhận ban đầu.',
  billingJob_confirmState: 'Đã xác nhận chưa',
  billingJob_creator: 'Người tạo',
  billingJob_dateCreated: 'Ngày tạo',
  billingJob_remarks: 'Ghi chú',
  billingJob_customerLevel: 'Cấp độ khách hàng',
  billingJob_settlementMethod: 'Phương thức thanh toán',
  billingJob_chargesContactPerson: 'Người liên hệ phí',
  billingJob_confirmUser: 'Người xác nhận phí',
  billingJob_updateUser: 'Người cập nhật chi phí',
  billingJob_settleAccountsTo: 'Đối tượng thanh toán',
  billingJob_otherPartyBilling: 'Số đối chiếu của đối tác',
  billingJob_customer: 'Khách hàng',
  billingJob_portOfDischarge: 'Cảng dỡ hàng',
  billingJob_dateOfDeparture: 'Ngày khởi hành',
  billingJob_bookingAgent: 'Đại lý đặt chỗ',
  billingJob_revenueAndExpenditureType: 'Loại thu chi',
  billingJob_chargesTotalAmount: 'Tổng số tiền chi phí',
  billingJob_dateOfArrival: 'Ngày đến cảng',
  billingJob_billDate: 'Ngày hóa đơn',
  billingJob_invoiceDate: 'Ngày xuất hóa đơn',
  billingJob_originalCurrency: 'Loại tiền gốc',
  billingJob_billAndCurrency: 'Loại tiền hóa đơn',
  billing_billAmount: 'Số tiền hóa đơn',
  billingJob_operationDepartment: 'Bộ phận thao tác',
  billingJob_generatedAccountStatement: 'Đã tạo đối chiếu chưa?',
  billingJob_wroteOff: 'Đã thanh toán chưa?',
  billingJob_aging: 'Tuổi nợ (ngày)',
  billingJob_agentBillNo: 'Số hóa đơn đối tác',
  billingJob_billStatus: 'Trạng thái hóa đơn',
  billingJob_accountStatementNo: 'Số đối chiếu',
  billingJob_invoicingRequirements: 'Yêu cầu xuất hóa đơn',
  billingJob_proofDate: 'Ngày chứng từ',
  billingJob_customerService: 'Dịch vụ khách hàng',
  billingJob_invoicingStatus: 'Trạng thái xuất hóa đơn',
  billingJob_writeOffStatus: 'Trạng thái thanh toán',
  billingJob_writeOffStatus_bill: 'Trạng thái thanh toán hóa đơn',
  billingJob_writeOffStatus_reconciliation: 'Trạng thái thanh toán đối chiếu',
  billingJob_amountOfMoney: 'Số tiền',
  billingJob_notInvoicedMoney: 'Số tiền chưa xuất hóa đơn',
  billingJob_totalCurrency: 'Tổng theo loại tiền',
  billingJob_totalAmountNotWrittenOff: 'Tổng số tiền chưa thanh toán',
  billingJob_taxRate: 'Thuế suất (%)',
  billingJob_customJobType: 'Loại nghiệp vụ tùy chỉnh',
  billingJob_voyageLine: 'Tuyến đường',
  billingJob_separateNumber: 'Số vận đơn phụ',
  billingJob_dateTo: 'Đến',
  billingJob_lockCheckBoxDate: 'Truy vấn dữ liệu ngoài 2 năm',
  billingJob_inputDateNotEmpty: 'Ngày hóa đơn không được để trống!',
  billingJob_unlockInputDateQuery: 'Nếu phạm vi ngày hóa đơn chọn lớn hơn 2 năm sẽ ảnh hưởng tốc độ tải dữ liệu, bạn có chắc muốn truy vấn dữ liệu ngoài 2 năm không?',
  billingJob_billPaymentDate: 'Ngày YC',
  billingJob_billPaymentDateNotEmpty: 'Ngày yêu cầu không được để trống!',
  billingJob_unlockBillPaymentDateQuery: 'Nếu phạm vi ngày yêu cầu chọn lớn hơn 2 năm sẽ ảnh hưởng tốc độ tải dữ liệu, bạn có chắc muốn truy vấn dữ liệu ngoài 2 năm không?',
  billingJob_userDefinedField1: 'Trường tùy chỉnh 1',
  billingJob_userDefinedField2: 'Trường tùy chỉnh 2',
  billingJob_userDefinedField3: 'Trường tùy chỉnh 3',
  billingJob_userDefinedField4: 'Trường tùy chỉnh 4',
  billingJob_markDate: 'Thời gian đánh dấu',
  billingJob_markUser: 'Người đánh dấu',
  billingJob_markStatus: 'Trạng thái đánh dấu',
  billingJob_mark: 'Đã đánh dấu hay chưa',
  billingJob_vesselAndVoyageAndFlight: 'Tên tàu/Chuyến',
  billingJob_billPaymentOrNot: 'Đã yêu cầu thanh toán hay chưa',
  billingJob_voyageAndFlight: 'Chuyến bay/Chuyến',
  billingJob_containerDescription: 'Mô tả số lượng container',
  billingJob_InputDate: 'Ngày lập đơn bảng kê',

  billingView_total: 'Tổng cộng',
  billingView_query: 'Tìm kiếm',
  billingView_newAccountStatement: 'Tạo bảng đối chiếu mới',
  billingView_edit: 'Chỉnh sửa',
  billingView_delete: 'Xóa',
  billingView_view: 'Xem',
  billingView_confirm: 'Xác nhận',
  billingView_cancelConfirmation: 'Hủy xác nhận',
  billingView_print: 'In',
  billingView_drawCollectInvoice: 'Xuất hóa đơn/Nhận hóa đơn',
  billingView_writeOff: 'Thanh toán',
  billingView_applyForPayment: 'Yêu cầu thanh toán',
  billingView_revenueAndExpenditureMethod: 'Phương thức thu chi',
  billingView_receivables: 'Phải thu',
  billingView_payables: 'Phải trả',
  billingView_all: 'Tất cả',
  billingView_billType: 'Loại hóa đơn',
  billingView_domestic: 'Nội địa',
  billingView_international: 'Quốc tế',
  billingView_reconciliationType: 'Loại đối chiếu',
  billingView_accordingToBusiness: 'Theo nghiệp vụ',
  billingView_accordingToCharges: 'Theo chi phí',
  billingForm_taxAmount: 'Số tiền bao gồm thuế',
  billingForm_taxFreeAmount: 'Số tiền không bao gồm thuế',
  billingForm_bankOfDeposit: 'Ngân hàng mở tài khoản',
  billingForm_bankAccount: 'Số tài khoản ngân hàng',
  billingForm_collectAndPrepaidOrNot: 'Đã thu hộ/ứng trước hay chưa',
  billingForm_unit: 'Đơn vị',
  billingAccount_accountStatementType: 'Loại bảng đối chiếu',
  billingAccount_writeOffOrNot: 'Đã thanh toán hay chưa',
  billingAccount_invoicingInformation: 'Thông tin hóa đơn',
  billingGroup_dateOfFiling: 'Ngày lập đơn',
  billingGroup_settleAccountsTo: 'Đối tượng thanh toán',
  billingGroup_invoicingAddress: 'Địa chỉ xuất hóa đơn',
  billingGroup_addBill: ' 加入账单',
  billingGroup_deleteBill: 'Loại bỏ khỏi hóa đơn',
  billingGroup_previous: 'Trước',
  billingGroup_next: 'Tiếp theo',
  billingJob_settlementAgent: 'Đại lý thanh toán',
  billingJob_billingCreator: 'Người tạo hóa đơn',
  Query: 'Tìm kiếm',
  View: 'Xem',
  Add: 'Thêm mới',
  Edit: 'Chỉnh sửa',
  Delete: 'Xóa',
  print: 'In',
  statistics: 'Thống kê',
  ExportAllExcel: 'Xuất tất cả ra Excel',
  BusinessNo: 'Mã nghiệp vụ',
  WarehouseNo: 'Mã nhập kho',
  WayBillNumber: 'Số vận đơn',
  Destination: 'Trạm đích',
  PortOfDestination: 'Cảng đích',
  WarehouseEntryTime: 'Thời gian nhập kho',
  DeliveryTime: 'Thời gian xuất kho',
  InputTime: 'Thời gian nhập liệu',
  DataEntryClerk: 'Người nhập liệu',
  NumberOfCases: 'Số kiện',
  Weight: 'Trọng lượng',
  Volume: 'Thể tích',
  ComputationIsAffectedByDampness: 'Hư hỏng/Ẩm ướt',
  IntoTheWarehousePhotos: 'Ảnh nhập kho',
  WarehouseName: 'Tên kho',
  Warehouseman: 'Nhân viên kho',
  StorageLocation: 'Vị trí kho',
  Receiptnumber: 'Mã biên nhận',
  BlNo: 'Số vận đơn (Bill)',
  UploadFile: 'Tải lên tệp',
  batchdownload: 'Tải hàng loạt',
  ResetFilter: 'Đặt lại điều kiện',
  billingCharge_billingGroupNo: 'Số đối chiếu',
  modifiedBy: 'Người chỉnh sửa',
  dateModified: 'Ngày chỉnh sửa',
  invoiceHeader: 'Tiêu đề hóa đơn',
  revenueOrExpenditure: 'Thu chi',
  InvoicingAmount: 'Số tiền hóa đơn',
  invoicingExchangeRate: 'Tỷ giá hóa đơn',
  invoiceInformation: 'Thông tin hóa đơn',
  LoadingPort: 'Cảng xếp hàng',
  seaportOfDischarge: 'Cảng dỡ hàng (cảng biển)',
  billingJob_confirmDate: 'Thời gian xác nhận hóa đơn',
  billingJob_theAmountOfNotWriteOffs: 'Số tiền chưa thanh toán',
  QueryAgencyShareBill: 'Tra cứu hóa đơn chia sẻ đại lý',
  ForceDeleteBilling: 'Hóa đơn {0}{1} không thể xóa cưỡng chế.',
  HasBillPayment: 'Đã nộp yêu cầu thanh toán',
  HasBillingGroup: 'Đã tạo đối chiếu',
  HasWriteOff: 'Đã thanh toán',
  HasClosingAccount: 'Đã khóa sổ',
  OppositeBillNoAlreadyExists: '<strong>Số hóa đơn đối tác</strong> đã tồn tại, có tiếp tục không?',
  DueDate: 'Ngày đáo hạn phí',
  DueDateDirty: 'Trạng thái tính ngày đáo hạn',
  InCalculation: 'Đang tính toán',
  NotCalculated: 'Không tính',
  Calculated: 'Đã tính toán',
  CancelConfirmedBillSameTime: 'Có hủy xác nhận hóa đơn đồng thời không?',
  BillingConfirmStatus: 'Trạng thái xác nhận hóa đơn',
  ApplyForInvoicing: 'Yêu cầu xuất hóa đơn',
  BillSettlementType: 'Loại thanh toán hóa đơn',
  CostCannotExceed3Currencies: 'Chi phí không được vượt quá 3 loại tiền tệ',
  DomesticBill: 'Hóa đơn nội địa',
  Currency: 'Loại tiền tệ',
  CannotRemoveAllFees: 'Không thể xóa toàn bộ chi phí!',
  InvalidDate: 'Ngày hủy bỏ',
  Bill: 'Hóa đơn:',
  Billing_Requirements: 'Yêu cầu xuất hóa đơn',
  ForeignInvoiceTime: 'Thời gian xuất hóa đơn quốc tế'
}
